<template>
    <v-layout column>
        <v-progress-linear v-if="bldg && buildingRooms.length==0" class="mt-0 mb-0" color="blue" indeterminate></v-progress-linear>
        <v-card v-if="previewOpen" style="color: black"
                class="mt-2">
                    

                        <v-card class="pb-4">
                            <v-flex v-if="!selectedRoom" xs12 class="subheading pt-3">
                                <v-layout align-center justify-center row fill-height class="mt-4 pt-5 headline">                  
                                        Room Preview
                                </v-layout>                
                            </v-flex>
                            <v-flex v-if="selectedRoom" xs12 class="">
                                <v-card-title class="headline pb-1">
                                    <v-layout column>
                                        <v-layout row justify-space-between>
                                            <v-flex xs11 class="text-truncate pb-1"> {{bldg.name}}</v-flex>
                                            
                                            <v-flex xs1 v-if="roomPhotoURL" class="text-xs-right">
                                                <v-dialog max-height="90vh" v-model="photoPopup">
                                                    <template v-slot:activator="{ on }">
                                                        <v-icon color="purple" class="pb-2" v-on="on">photo</v-icon>
                                                    </template>
                                                    <v-img max-height="90vh" contain 
                                                        :src="roomPhotoURL" 
                                                     @click="photoPopup=false" />   
                                                </v-dialog>
                                            </v-flex>
                                        </v-layout>
                                        
                                        <v-layout row justify-space-between>

                                            <v-flex xs2 class="">
                                                {{selectedRoom.number}}
                                            </v-flex>
                                        
                                            <v-flex xs10 class="text-xs-right">
                                            {{selectedRoom.area.toLocaleString()}} sqft
                                            </v-flex>

                                        </v-layout>
                                    </v-layout>                                
                                </v-card-title>

                                <v-list class="ml-2" >
                                    <v-list-tile 
                                        v-for="(item, index) in items" 
                                        v-if="(item.val && item.val !== 'None')"
                                        :to="item.to" 
                                        :key="index" 
                                        class="mb-1 rptile">

                                            <v-flex xs class="font-weight-regular text-xs-right">
                                                <v-card class="body-1 px-2 py-1 mr-2 text-xs-right" style="background-color: #FFFFFF77">{{item.label}}</v-card>
                                            </v-flex>

                                            <v-flex xs9 class="font-weight-bold">
                                                <v-card :class="item.val.length > 60 ? 'caption' : 'body-1'"
                                                 class="px-2 py-1" style="background-color: #FFFFFF77">{{item.val}}</v-card>
                                             </v-flex>


                                    </v-list-tile>
                                    <v-list-tile 
                                         
                                        class="mb-1 rptile">

                                            <v-flex xs3 class="font-weight-regular text-xs-right">
                                                <v-card class="body-1 px-2 py-1 mr-2 text-xs-right" style="background-color: #FFFFFF77">Capacity</v-card>
                                            </v-flex>

                                            <v-flex xs3 class="font-weight-bold">
                                                <v-card class="body-1 px-2 py-1 mr-2" style="background-color: #FFFFFF77">{{selectedRoom.capacity}}</v-card>
                                            </v-flex>
                                            <v-flex v-if="selectedRoom.classification!='None'" 
                                                xs3 class="font-weight-regular text-xs-right">
                                                <v-card class="body-1 px-2 py-1 mr-2 text-xs-right" style="background-color: #FFFFFF77">Class</v-card>
                                            </v-flex>

                                            <v-flex v-if="selectedRoom.classification!='None'" 
                                                xs3 class="font-weight-bold">
                                                <v-card class="body-1 px-2 py-1 mr-2" style="background-color: #FFFFFF77">{{selectedRoom.classification}}</v-card>
                                            </v-flex>


                                    </v-list-tile>
                                </v-list>
                            </v-flex>
                            
                        </v-card>   
                           
        </v-card>

                    
        <v-flex class="text-xs-center"
                :class="previewOpen ? 'collapseButtonRCOpen' : 'collapseButtonRCClosed'">
            <v-btn icon style="color: darkgrey">
                <v-icon @click="previewOpen = !previewOpen"
                large class="collapseIconRC">{{previewOpen ? 'expand_less' : 'expand_more'}}</v-icon>
            </v-btn>
        </v-flex>
    </v-layout>
</template>

<script>
    import { mapActions, mapMutations, mapState } from 'vuex'

    let RoomPreview = {

        data() {
          return {  photoPopup: false,
                    previewOpen: true,

          }
        },

        components: {  },

        computed: {
            ...mapState({
                    bldg: state => state.space.selectedBuilding,
                    selectedRoom: state => state.space.selectedRoom,
                    buildingRooms: state => state.space.buildingRooms,
                    fullRoom: state => state.space.fullRoom,
            }),
            items: function () {
                if (this.selectedRoom && this.bldg) {
                return [
/*                        { label: 'Number', val: this.selectedRoom.number },
                        { label: 'Building', val: this.selectedRoom.bldgAlpha },
                        { label: 'Floor', val: this.selectedRoom.floor }, 
                        { label: 'Area', val: this.selectedRoom.area + " sf"}, */
                        { label: 'Building', val: this.selectedRoom.bldgAlpha + " - " + this.bldg.name },
                        { label: 'College', val: this.selectedRoom.collegeName + " (" + this.selectedRoom.collegeID + ")" },
                        { label: 'Dept', val: this.selectedRoom.deptName + " (" + this.selectedRoom.deptID + ")" },
                        { label: 'Type', val: this.selectedRoom.typeName + " (" + this.selectedRoom.type + ")" },
                        { label: 'Use', val: this.selectedRoom.useName + " (" + this.selectedRoom.use + ")" },
                        { label: 'PI', val: this.getPIText(this.selectedRoom) },
                        { label: 'Occupant', val: this.getOccupantText(this.selectedRoom) },
                        //{ label: 'Capacity', val: this.selectedRoom.capacity },
                        //{ label: 'Class', val: this.selectedRoom.classification},
                    ]
                }
            },

            roomPhotoURL : function () {
                return this.selectedRoom && this.selectedRoom.roomImages && this.selectedRoom.roomImages.length > 0 && this.selectedRoom.roomImages[0].url 
            },            

/*            imageAvailable: function () {
                return this.selectedRoom && this.selectedRoom.roomImages && this.selectedRoom.roomImages.length > 0
            },*/

        },

        methods: {
            ...mapActions(['fetchRoomPhotos']),
            //...mapMutations([   '',
            //                ]),

            getPIText : function(room) {
                let PIs = []
                this.selectedRoom.PCT.map((pct) => {
                    pct.PI.map((PI) => {
                        PIs.push(PI.name)
                    })                      
                })
                
                let text = ""
                PIs.forEach((name) => { text += name + ", " })

                // Switch to last names if over threshold
                if (text.length > 60) {
                    let PIs = []
                    this.selectedRoom.PCT.map((pct) => {
                        pct.PI.map((PI) => {
                            PIs.push(PI.nameLast)
                        })                      
                    })

                    text = ""
                    PIs.forEach((nameLast) => { text += nameLast + ", " })
                }

                return (text.length > 0 ) ? text.replace(/,\s*$/, "") : "" // removes final comma
            },

            getOccupantText : function(room) {
                let occupants = []
                this.selectedRoom.PCT.map((pct) => {
                    pct.occupant.map((occupant) => {
                        occupants.push(occupant.name)
                    })                      
                })
                
                let text = ""
                occupants.forEach((name) => { text += name + ", " })

                // Switch to last names if over threshold
                if (text.length > 60) {
                    let occupants = []
                    this.selectedRoom.PCT.map((pct) => {
                        pct.occupant.map((occupant) => {
                            occupants.push(occupant.nameLast)
                        })                      
                    })

                    text = ""
                    occupants.forEach((nameLast) => { text += nameLast + ", " })
                }

                return (text.length > 0 ) ? text.replace(/,\s*$/, "") : "" // removes final comma
            }
            
        }
    }

    export default RoomPreview
</script>

<style>

.rptile {
    height: 28px;
}

.collapseButtonRCOpen {
    position: relative; 
    top: -20px; 
    z-index:1; 
}

.collapseButtonRCClosed {
    position: relative; 
    top: -10px; 
    z-index:1; 
}

.collapseIconRC {
    border-style: solid;
    border-radius: 20px;
    border-width: 1px;
    border-color: #00000055;
    background-color: white;
}

</style>



// WEBPACK FOOTER //
// src/components/RoomCollector/RoomPreview.vue